import { FcGoogle } from "react-icons/fc";
import { useSelector } from "react-redux";

import frameImg from "../../assets/image/frame.jpg";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import "./Template.css";

function Template({ title, description1, description2, image, formType }) {
  const { loading } = useSelector((state) => state.auth);

  return (
    <div className="template-container">
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <div className="template-content">
          <div className="text-section">
            <h1 className="title">{title}</h1>
            <p className="description">
              <span className="description-main">{description1}</span>
              <span className="description-highlight">{description2}</span>
            </p>
            {formType === "signup" ? <SignupForm /> : <LoginForm />}
          </div>
          <div className="image-section">
            <img src={frameImg} className="frame-img" alt="Pattern" loading="lazy" />
            <img src={image} alt="Students" className="overlay-img" loading="lazy" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Template;